// prettier-ignore
export const  LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path fill="#B7B8C1" fillRule="evenodd" d="M1.67 2.5c0-.46.37-.83.83-.83H10a.83.83 0 0 1 0 1.66H3.33v13.34H10a.83.83 0 1 1 0 1.66H2.5a.83.83 0 0 1-.83-.83v-15Z" clipRule="evenodd"/>
    <path fill="#B7B8C1" d="M14.34 5.66a.83.83 0 1 0-1.18 1.18l2.32 2.32H6.67a.83.83 0 1 0 0 1.67h8.82l-2.33 2.33a.83.83 0 1 0 1.18 1.18l3.75-3.75a.83.83 0 0 0 0-1.18l-3.75-3.75Z"/>
  </svg>
)
